import script from './component-lib.esm4.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('details', {
    staticClass: "accordion-item",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('summary', {
    staticClass: "accordion-item__title"
  }, [_c('span', {
    staticClass: "accordion-item__title__inner"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n      "), _c('FlexSpacer'), _vm._v(" "), _c('span', {
    staticClass: "accordion-item__title__arrow"
  }, [_c('ChevronIcon', {
    attrs: {
      "direction": "down",
      "size": "1.25em"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "accordion-item__content"
  }, [_vm._t("default")], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-034f482b_0", {
    source: ".accordion-item[data-v-034f482b]{background:var(--c-bg-color);border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));color:var(--c-color);text-align:left}.accordion-item--outline[data-v-034f482b]{background:0 0;border:.125rem solid var(--c-bg-color);color:var(--c-bg-color)}.accordion-item[open] .accordion-item__title__arrow[data-v-034f482b]{transform:rotate(180deg)}.accordion-item__title[data-v-034f482b]{cursor:pointer;font-weight:var(--g-font-header-weight);font-family:var(--g-font-header-family);font-size:1.125rem;list-style:none;padding:1rem;position:relative}.accordion-item__title__inner[data-v-034f482b]{align-items:center;display:flex}.accordion-item__title__arrow[data-v-034f482b]{display:inline-flex;transition:all var(--g-transition-speed)}.accordion-item__title[data-v-034f482b]::-webkit-details-marker{display:none}.accordion-item__content[data-v-034f482b]{padding:1rem}.accordion-item__content p[data-v-034f482b]{color:inherit;margin-bottom:1.25rem}.accordion-item__content p[data-v-034f482b]:last-child{margin-bottom:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-034f482b";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };